import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const HumorEditor = ({ content, onChange }) => {
  const handleChange = (field, value) => {
    onChange({
      ...content,
      [field]: value
    });
  };

  const emojiReactions = [
    { emoji: '😂', label: 'Çok Komik' },
    { emoji: '😊', label: 'Güzel' },
    { emoji: '👍', label: 'Beğendim' },
    { emoji: '❤️', label: 'Sevdim' },
    { emoji: '🔥', label: 'Harika' }
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-lg bg-warning/10 flex items-center justify-center">
          <Icon name="Smile" size={20} color="var(--color-warning)" />
        </div>
        <div>
          <h4 className="text-base md:text-lg font-heading font-semibold text-foreground">
            Eğlence İçeriği
          </h4>
          <p className="caption text-muted-foreground">
            Kullanıcıları güldürecek veya eğlendirecek içerik oluşturun
          </p>
        </div>
      </div>
      <Input
        label="İçerik Başlığı"
        type="text"
        placeholder="Örn: Günün Trafik Esprisi"
        value={content?.title || ''}
        onChange={(e) => handleChange('title', e?.target?.value)}
        required
        description="Eğlenceli ve dikkat çekici bir başlık"
      />
      <div>
        <label className="block text-sm font-medium text-foreground mb-2">
          Eğlence İçeriği
          <span className="text-destructive ml-1">*</span>
        </label>
        <textarea
          className="flex w-full rounded-lg border border-input bg-input px-4 py-3 text-sm focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring focus-visible:ring-offset-3 disabled:cursor-not-allowed disabled:opacity-50 min-h-32 md:min-h-40"
          placeholder="Espri, komik hikaye veya eğlenceli bilgi yazın..."
          value={content?.content || ''}
          onChange={(e) => handleChange('content', e?.target?.value)}
          required
        />
        <p className="caption text-muted-foreground mt-2">
          Trafik temalı espri, komik anekdot veya eğlenceli bilgi paylaşın
        </p>
      </div>
      <div className="p-4 md:p-6 rounded-lg bg-muted border border-border">
        <div className="flex items-center gap-2 mb-3">
          <Icon name="Heart" size={18} color="var(--color-warning)" />
          <span className="text-sm font-medium text-foreground">Emoji Tepkileri</span>
        </div>
        <div className="flex flex-wrap gap-3">
          {emojiReactions?.map((reaction, index) => (
            <div
              key={index}
              className="flex items-center gap-2 px-3 py-2 rounded-lg bg-background border border-border"
            >
              <span className="text-xl md:text-2xl">{reaction?.emoji}</span>
              <span className="caption text-muted-foreground">{reaction?.label}</span>
            </div>
          ))}
        </div>
        <p className="caption text-muted-foreground mt-3">
          Kullanıcılar bu emoji'lerle tepki verebilecek
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="p-4 rounded-lg bg-warning/10 border border-warning/20">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Lightbulb" size={16} color="var(--color-warning)" />
            <span className="text-sm font-medium text-foreground">İçerik Önerileri</span>
          </div>
          <ul className="caption text-muted-foreground space-y-1">
            <li>• Trafik esprileri</li>
            <li>• Komik sürücü hikayeleri</li>
            <li>• Eğlenceli trafik bilgileri</li>
          </ul>
        </div>

        <div className="p-4 rounded-lg bg-muted border border-border">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="AlertCircle" size={16} color="var(--color-muted-foreground)" />
            <span className="text-sm font-medium text-foreground">Dikkat</span>
          </div>
          <p className="caption text-muted-foreground">
            İçerik eğlenceli olmalı ama trafik güvenliğini hafife almamalı
          </p>
        </div>
      </div>
    </div>
  );
};

export default HumorEditor;